// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertsContainer_container__2rKp7"};